/* eslint-disable camelcase */
import { gql } from '@apollo/client'

export type {
  CompanyWithUsers,
  CompanyWithUsersVariables,
  CompanyWithUsers_company_usersRoles as UserRole,
  CompanyWithUsers_company_invitations as Invitation,
} from './types/CompanyWithUsers'
export type { LeaveCompany, LeaveCompanyVariables } from './types/LeaveCompany'
export type { ChangeUserRole, ChangeUserRoleVariables } from './types/ChangeUserRole'
export type { InviteUser, InviteUserVariables } from './types/InviteUser'

export const COMPANY_WITH_USERS = gql`
  query CompanyWithUsers($id: Int!) {
    company(id: $id) {
      id
      name
      logo
      governmentId
      subregionId
      organization {
        id
      }
      country {
        id
      }
      usersRoles {
        role
        user {
          id
          email
          name
          lastName
          isVerified
          profilePicture
        }
      }
      invitations {
        id
        email
        role
      }
    }
  }
`

export const LEAVE_COMPANY = gql`
  mutation LeaveCompany($companyId: Int!, $userId: Int!) {
    leaveCompany(companyId: $companyId, userId: $userId) {
      user {
        id
        email
        companiesRoles {
          role
          company {
            id
            name
            country {
              id
              lng
              code
            }
          }
        }
      }
    }
  }
`

export const CHANGE_USER_ROLE = gql`
  mutation ChangeUserRole($userId: Int!, $companyId: Int!, $role: UserCompanyRole!) {
    changeUserRole(userId: $userId, companyId: $companyId, role: $role) {
      company {
        id
        name
        usersRoles {
          role
          user {
            id
            email
          }
        }
      }
    }
  }
`

export const INVITE_USER = gql`
  mutation InviteUser($inviteUserDTO: InviteUserInput!) {
    inviteUser(inviteUserDTO: $inviteUserDTO) {
      company {
        id
        name
        usersRoles {
          role
          user {
            id
            email
          }
        }
        invitations {
          id
          email
          role
        }
      }
    }
  }
`
